import { useEffect } from "react";
import Lenis from "lenis";

export const EASE = [0.22, 1, 0.36, 1];

let lenis = null;
const HEADER_OFFSET = -64;

const reduced = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const introSeen = typeof window !== "undefined" && sessionStorage.getItem("ed-intro") === "1";
export const SHOW_INTRO = !introSeen && typeof window !== "undefined" && !reduced();
export const INTRO_DELAY = SHOW_INTRO ? 1.55 : 0.15;

export const scrollToTarget = (target, immediate = false) => {
  const el = typeof target === "string" ? document.querySelector(target) : null;
  if (typeof target === "string" && !el) return;
  if (lenis) {
    lenis.scrollTo(el ?? 0, { offset: el ? HEADER_OFFSET : 0, duration: 1.6, immediate });
    return;
  }
  const top = el ? el.getBoundingClientRect().top + window.scrollY + HEADER_OFFSET : 0;
  window.scrollTo({ top, behavior: immediate || reduced() ? "auto" : "smooth" });
};

export const lockScroll = (locked) => {
  if (lenis) locked ? lenis.stop() : lenis.start();
  document.body.style.overflow = locked ? "hidden" : "";
};

export const useSmoothScroll = () => {
  useEffect(() => {
    if (reduced()) return undefined;
    lenis = new Lenis({ lerp: 0.085, wheelMultiplier: 1 });
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      lenis = null;
    };
  }, []);
};

export const useMeta = (title, description) => {
  useEffect(() => {
    document.title = title;
    const tag = document.querySelector('meta[name="description"]');
    if (tag && description) tag.setAttribute("content", description);
  }, [title, description]);
};
